function initializeMap(mapElement) {
    if (
        !mapElement
        || mapElement.dataset.isInitialized === 'true'
        || !window.google
        || !window.google.maps
    ) {
        return false;
    }

    const latitude = Number(mapElement.dataset.lat);
    const longitude = Number(mapElement.dataset.lng);

    if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
        return false;
    }

    const position = {
        lat: latitude,
        lng: longitude,
    };
    const map = new window.google.maps.Map(mapElement, {
        zoom: 16,
        center: position,
    });

    new window.google.maps.Marker({
        position,
        map,
    });

    mapElement.dataset.isInitialized = 'true';

    return true;
}

export function initContactsSection() {
    const sections = document.querySelectorAll('.js-contacts-section');

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const tabs = section.querySelectorAll('[data-contacts-tab]');
        const panels = section.querySelectorAll('.contacts__panel');
        const initializeActiveMap = () => {
            const activePanel = section.querySelector('.contacts__panel--active');
            const mapElement = activePanel?.querySelector('[data-contacts-map]');

            return initializeMap(mapElement);
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const panelId = tab.dataset.contactsTab;
                const activePanel = section.querySelector(`#${panelId}`);

                if (!activePanel) {
                    return;
                }

                tabs.forEach((item) => {
                    const isActive = item === tab;

                    item.classList.toggle('contacts__tab--active', isActive);
                    item.setAttribute('aria-selected', String(isActive));
                });

                panels.forEach((panel) => {
                    const isActive = panel === activePanel;

                    panel.classList.toggle('contacts__panel--active', isActive);
                    panel.setAttribute('aria-hidden', String(!isActive));
                });

                initializeActiveMap();
            });
        });

        if (!initializeActiveMap()) {
            window.addEventListener('load', initializeActiveMap, { once: true });
        }
    });
}
